import React from 'react'
import styles from './Report.styles'
import { componentKey, setDropDownOptions, setExportFile, setFilterText, setFromDate, setGridData, setGridTotal, setHeaders, setMultiSelectdropDownOptions, setPayerDropdownPagination, setRowsPerPage, setSecondaryDropDownOptions, setSelectedDropDownOption, setSelectedMultiSelectdropDownOptions, setSelectedSecondaryDropDownOptions, setSkip, setToDate, setUSPSAmount, setXlsx, setPayrollSelectedState, setSelectedForm, setFormList } from './ReportSlice'
import { useDispatch, useSelector } from 'react-redux'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import CheckboxWLabel from '../../../components/checkbox/checkboxwlabel/CheckboxWLabel'
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator'
import RadioInputWCard from '../../../components/input/radioinput/radioinputwcard/RadioInputWCard'
import CalendarInput from '../../../components/input/calendarinput/CalendarInput'
import Button from '../../../components/button/Button'
import { useEffect } from 'react'
import { get1099VendorCopyeDeliveryExport, get1099VendorCopyeDeliveryGrid, getDeliveryHeader, getFederalTaxYears, getFormDeliveryReport, getForms, getInvoiceReport, getMemberUser, getOPTINReport, getOptInEmailStatusGrid, getOptInEmailStatusGridExport, getOptInReportHeader, getPayerReport, getPayerReportByUser, getPayerReportByUserHeader, getPayerReportHeader, getPayersList, getPaymentsReceiptsReportExport, getQBOVendorHistoryReportExport, getQBOVendorHistoryReportGridData, getRecipientHeader, getRecipientReport, getStateSubmissionHistoryReport, getSubmissionHistoryReport, getTINReport, getTaxYears, getTinReportHeader, getUSPSAmount, getUnsubmittedFormsGridData, getUnsubmittedFormsMultiPayerReport, getUnsubmittedFormsReport, getW8Report, getW8ReportHeader, getW9CopyStatusReportExport, getW9EmailStatusGrid, getW9Report, getW9ReportHeader, updateEmailId, getStatePayrollReportStates, getStatePayrollReportForms, getStatePayrollSubmissionHistoryReport } from './ReportSaga'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { useState } from 'react'
import MultiSelectDropdownWLabel from '../../../components/dropdown/multiselectdropdownwlabel/MultiSelectDropdownWLabel'
import { BUTTON_TYPE } from '../../../components/button/constants'
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants'
import RichGrid from '../../../components/richgrid/RichGrid'
import Label from '../../../components/label/Label'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import Loadable from '../../../components/loadable/Loadable'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { TOASTER_VARIANT } from '../../../components/toast/constants'
import Popup from '../../../components/popup/Popup'
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks"
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import TabbedNavigationWithDefinedTitle from '../../../components/tabbednavigation/TabbedNavigationWithDefinedTitle'
import { ALL_SELECTED, EMAIL_REQUEST_VALUE, FORM_DELIVERY_REPORT_VALUE, GENERATE_INVOICE_VALUE, NONE_SELECTED, OPT_IN_REPORT_VALUE, PAYER_REPORT_BY_USER_VALUE, PAYER_REPORT_VALUE, PAYMENT_RECEIPTS_REPORT_VALUE, QBO_VENDOR_VALUE, RECIPIENT_REPORT_VALUE, REPORT_LOADING_STATES, REPORT_LOADING_STATES_MESSAGE_MAP, SELECT_ALL, SELECT_FORMS, SELECT_PAYERS, SELECT_TAX_YEAR, SELECT_USER, STATE_SUBMITTED_REPORT_VALUE, SUBMITTED_REPORT_VALUE, TIN_REPORT_VALUE, UNSUBMITTED_REPORT_VALUE, W8_REPORT_VALUE, W9_REPORT_VALUE, reportOptions, tabListWithTitleObj, STATE_PAYROLL_SUBMITTED_REPORT_VALUE } from '../constants'
import DrawerWithTitleAndFooter from '../../../components/drawer/DrawerWithTitleAndFooter'
import TextInput from '../../../components/input/textinput/TextInput'
import DateUtils from '../../../../libs/utility/DateUtils'
import Icons from '../../../components/icons/Icons'
import { PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../../businesslogic/components/paymentdrawer/constants';
import PaymentDrawer from '../../../businesslogic/components/paymentdrawer/PaymentDrawer';
import ReportDataService from '../../../../services/ReportDataService'
import { isAccessAllowed, useUserPermissionsInfo } from '../../dashboard/hooks/userHooks'
import { PAGE_PERMISSIONS } from '../../dashboard/constants/constant'
import { setShowPaymentNotAllowedPopup } from '../../dashboard/DashboardSlice'
import useTxSearchParams from '../../../../libs/txsearchparams/TxSearchParamsHook'
import General from '../../../../libs/utility/General'
import useFormatTIN from '../../../../libs/customhooks/useFormatTIN'
import MultiSelectDropdown from '../../../components/multiselect/multiselectdropdown/MultiSelectDropdown'

export default function Report() {
	useGarbageCollector(componentKey);
	const { loadingState, uspsAmount, headers, isXlsx, fromDate, toDate, exportFile, selectedDropDownOption, dropDownOptions, filterText, multiSelectdropDownOptions, secondaryDropDownOptions, selectedSecondaryDropDownOptions, gridData, rowsPerPage, skip, gridTotal, payerDropdownPagination, selectedState, stateList, selectedForm, formList } = useSelector((state) => state[componentKey])

	const { formatTIN } = useFormatTIN()


	const [selectedReport, setSelectedReport] = useState(reportOptions[0])
	const [showExtension, setShowExtension] = useState(true)
	const [showGrid, setShowGrid] = useState(false)
	const [showEditDrawer, setShowEditDrawer] = useState(false)
	const [showHeaders, setShowHeaders] = useState(true)
	const [showDataFilter, setShowDataFilter] = useState(true)
	const [selectedPayersLabel, setSelectedPayersLabel] = useState(NONE_SELECTED)
	const [multiSelectLabel, setMultiSelectLabel] = useState(SELECT_PAYERS)
	const [dropdownLabel, setDropdownLabel] = useState(SELECT_USER)
	const [secondaryDropdownLabel, setSecondaryDropdownLabel] = useState(SELECT_TAX_YEAR)
	const [showPopup, setShowPopup] = useState(false);
	const [reloadData, setReloadData] = useState(false);
	const [showTabbedNavigation, setShowTabbedNavigation] = useState(false);
	const [showSecondaySubmitButton, setShowSecondaySubmitButton] = useState(false);
	const [secondarySubmitLabel, setSecondarySubmitLabel] = useState("")
	const [tabbedIndex, setTabbedIndex] = useState(null);
	const [queryParams, setQueryParams] = useTxSearchParams();
	const [selectedRecipient, setSelectedRecipient] = useState(null);
	const [selectedRows, setSelectedRows] = useState([]);
	const [showMultiSelectDropdown, setShowMultiSelectDropdown] = useState(false);
	const [showSelectDropdon, setShowSelectDropdon] = useState(false);
	const [showStateList, setShowStateList] = useState(true);
	const [showFormList, setShowFormList] = useState(true);

	const dispatch = useDispatch();
	const { permissions } = useUserPermissionsInfo();

	const resetState = () => {
		dispatch(setHeaders(null))
		setShowHeaders(true)
		dispatch(setSelectedDropDownOption({ label: ALL_SELECTED, value: ALL_SELECTED }))
		dispatch(setDropDownOptions([]))
		dispatch(setMultiSelectdropDownOptions([]))
		dispatch(setSelectedMultiSelectdropDownOptions(null))
		dispatch(setExportFile({}))
		dispatch(setSecondaryDropDownOptions({}))
		dispatch(setSelectedSecondaryDropDownOptions({}))
		setShowExtension(true)
		setSelectedPayersLabel(NONE_SELECTED)
		setSecondaryDropdownLabel(SELECT_TAX_YEAR)
		setShowGrid(false)
		dispatch(setGridData([]))
		dispatch(setGridTotal(0))
		setShowTabbedNavigation(false)
		setTabbedIndex(null)
		setShowSecondaySubmitButton(false)
		setSecondarySubmitLabel("")

		setShowSelectDropdon(false)
		setShowMultiSelectDropdown(false)
	}

	useEffect(() => {
		if (!queryParams.has('report')) {
			setSelectedReport(reportOptions[0])
		} else {
			setSelectedReport(reportOptions.find(report => report.value === queryParams.get('report')))
		}
	}, [])

	useEffect(() => {
		queryParams.set('report', selectedReport?.value);
		setQueryParams(queryParams);

		resetState();
		setShowStateList(false);
		setShowFormList(false);
		switch (selectedReport?.value) {
			default:
			case PAYER_REPORT_VALUE:
				dispatch(getPayerReportHeader())
				break;
			case PAYER_REPORT_BY_USER_VALUE:
				setShowSelectDropdon(true)
				dispatch(getPayerReportByUserHeader())
				break;
			case RECIPIENT_REPORT_VALUE:
				setShowMultiSelectDropdown(true)
				dispatch(getPayersList())
				dispatch(getRecipientHeader())
				break;
			case TIN_REPORT_VALUE:
				setShowMultiSelectDropdown(true)
				dispatch(getPayersList())
				dispatch(getTinReportHeader())
				break;
			case W9_REPORT_VALUE:
				setShowMultiSelectDropdown(true)
				dispatch(getPayersList())
				dispatch(getW9ReportHeader())
				break;
			case W8_REPORT_VALUE:
				setShowMultiSelectDropdown(true)
				dispatch(getPayersList())
				dispatch(getW8ReportHeader())
				break;
			case OPT_IN_REPORT_VALUE:
				setShowMultiSelectDropdown(true)
				dispatch(getPayersList())
				dispatch(getOptInReportHeader())
				break;
			case UNSUBMITTED_REPORT_VALUE:
				setShowSelectDropdon(true)
				setShowHeaders(false)
				dispatch(getPayersList({ isMultiSelect: true, isSingleSelect: true }))
				dispatch(getTaxYears())
				setDropdownLabel(SELECT_PAYERS)
				setShowExtension(false)
				setShowGrid(true)
				setShowSecondaySubmitButton(true)
				setSecondarySubmitLabel("Export To Excel For Multiple Payers")
				setShowDataFilter(true)
				break;
			case GENERATE_INVOICE_VALUE:
			case SUBMITTED_REPORT_VALUE:
				setShowHeaders(false)
				dispatch(getTaxYears())
				setShowExtension(false)
				setShowDataFilter(true)
				break;
			case STATE_SUBMITTED_REPORT_VALUE:
				setShowHeaders(false)
				dispatch(getTaxYears())
				setShowExtension(false)
				setSecondaryDropdownLabel(SELECT_FORMS)
				setShowDataFilter(true)
				break;
			case FORM_DELIVERY_REPORT_VALUE:
				dispatch(getTaxYears())
				dispatch(getDeliveryHeader())
				break;
			case QBO_VENDOR_VALUE:
				setShowHeaders(false)
				setShowExtension(false)
				setShowGrid(true)
				setShowDataFilter(false)
				break;
			case EMAIL_REQUEST_VALUE:
				setShowSelectDropdon(true)
				setShowHeaders(false)
				setShowExtension(false)
				setShowGrid(true)
				setShowDataFilter(false)
				setShowTabbedNavigation(true)
				dispatch(getPayersList({ isMultiSelect: false, isSingleSelect: true }))
				dispatch(getFederalTaxYears())
				setTabbedIndex(0)
				setShowSecondaySubmitButton(true)
				setSecondarySubmitLabel("USPS Mail to recipient")
				break;
			case PAYMENT_RECEIPTS_REPORT_VALUE:
				setShowDataFilter(true)
				break;
			case STATE_PAYROLL_SUBMITTED_REPORT_VALUE:
				setShowHeaders(false)
				dispatch(getStatePayrollReportStates())
				dispatch(getStatePayrollReportForms())
				setShowExtension(false)
				setShowDataFilter(true)
				setShowStateList(true)
				setShowFormList(true)
				break;
		}
	}, [selectedReport])

	useEffect(() => {
		switch (tabbedIndex) {
			case 0:
				if (!secondaryDropDownOptions) {
					dispatch(getFederalTaxYears())
				}
				setShowSecondaySubmitButton(true)
				break;
			case 2:
				if (!secondaryDropDownOptions) {
					dispatch(getFederalTaxYears())
				}
				dispatch(setGridData([]))
				dispatch(setGridTotal(0))
				dispatch(setSkip(0))
				dispatch(setRowsPerPage(10))
				setShowSecondaySubmitButton(false)
				break;
			case 1:
				dispatch(setSecondaryDropDownOptions(null))
				setShowSecondaySubmitButton(false)
				dispatch(setGridData([]))
				dispatch(setGridTotal(0))
				dispatch(setSkip(0))
				dispatch(setRowsPerPage(10))
				break;
		}
	}, [tabbedIndex])

	useEffect(() => {
		switch (selectedReport?.value) {
			case UNSUBMITTED_REPORT_VALUE:
				if (selectedDropDownOption && selectedDropDownOption.value !== ALL_SELECTED && selectedDropDownOption.value !== ALL_SELECTED && selectedSecondaryDropDownOptions?.value) {
					dispatch(getUnsubmittedFormsGridData({ rowsPerPage, skip, fromDate, toDate, taxYear: selectedSecondaryDropDownOptions.value, payerId: selectedDropDownOption.value }))
				}
				break;
			case QBO_VENDOR_VALUE:
				dispatch(getQBOVendorHistoryReportGridData({ rowsPerPage, skip }))
			case EMAIL_REQUEST_VALUE:
				if (selectedDropDownOption.value !== '' && selectedDropDownOption.value !== ALL_SELECTED) {
					switch (tabbedIndex) {
						case 0:
							if (selectedSecondaryDropDownOptions.value && selectedSecondaryDropDownOptions.value !== ALL_SELECTED && selectedSecondaryDropDownOptions.value !== '') {
								dispatch(get1099VendorCopyeDeliveryGrid({ PayerId: selectedDropDownOption.value, taxYear: selectedSecondaryDropDownOptions.value, skip, rowsPerPage }))
							}
							break;
						case 1:
							dispatch(getW9EmailStatusGrid({ PayerId: selectedDropDownOption.value, skip, rowsPerPage }))
							break;
						case 2:
							if (selectedSecondaryDropDownOptions.value && selectedSecondaryDropDownOptions.value !== ALL_SELECTED && selectedSecondaryDropDownOptions.value !== '') {
								dispatch(getOptInEmailStatusGrid({ PayerId: selectedDropDownOption.value, taxYear: selectedSecondaryDropDownOptions.value, skip, rowsPerPage }))
							}
							break;
					}
				}
		}
	}, [rowsPerPage, skip, selectedDropDownOption, selectedSecondaryDropDownOptions, fromDate, toDate, tabbedIndex, reloadData])

	useEffect(() => {
		switch (selectedReport?.value) {
			case PAYER_REPORT_BY_USER_VALUE:
				dispatch(getMemberUser(filterText))
				break;
		}
	}, [filterText, selectedReport])

	const onChangeSelectAllCb = (e) => {
		dispatch(setHeaders(headers.map(head => ({ ...head, value: e.target.checked }))))
	}

	const onChangeReportHeadersCb = (e) => {
		dispatch(setHeaders(headers.map(head => {
			if (head.key === e.target.name) {
				return { ...head, value: e.target.checked }
			}
			return head
		})))
	}

	const onChangeCalendarInputCb = (e) => {
		const name = e.target.name
		switch (name) {
			case 'fromDate':
				dispatch(setFromDate(e.target.value))
				break;
			case 'toDate':
				dispatch(setToDate(e.target.value))
				break;
		}
	}

	const onChangeFileFormatCb = (e) => {
		dispatch(setXlsx(e.target.checked))
	}

	useEffect(() => {
		General.downloadFileWithBase64AndName(exportFile)
	}, [exportFile])

	const formatHeaderForExport = () => {
		return headers.reduce(
			(obj, item) => Object.assign(obj, { [item.key]: item.value }), {})
	}

	const isAllUsersSelected = () => {
		return multiSelectdropDownOptions[0]?.checked ?? false
	}

	const getPayerIdsArray = (IsAllUsers) => {
		switch (selectedReport?.value) {
			case TIN_REPORT_VALUE:
			case W9_REPORT_VALUE:
			case W8_REPORT_VALUE:
			case OPT_IN_REPORT_VALUE:
				return multiSelectdropDownOptions.filter(opts => opts.checked && opts.value !== ALL_SELECTED).map(opt => opt.value)
			default:
				return IsAllUsers ? [] : multiSelectdropDownOptions.filter(opts => opts.checked).map(opt => opt.value)
		}
	}

	const validatePayers = (IsAllUsers) => {
		if (!IsAllUsers && getPayerIdsArray(IsAllUsers).length === 0) {
			dispatch(addNotifications({
				heading: 'Error',
				message: 'Please select Payers',
				variant: TOASTER_VARIANT.DANGER
			}))
			return false
		}
		return true
	}

	const handleRunReport = (e) => {
		switch (selectedReport?.value) {
			case PAYER_REPORT_VALUE:
				dispatch(getPayerReport({
					PayerFileds: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx
				}))
				break;
			case PAYER_REPORT_BY_USER_VALUE:
				const MemberId = selectedDropDownOption.value === ALL_SELECTED ? null : selectedDropDownOption.value;
				let IsAllUsers = selectedDropDownOption.value === ALL_SELECTED

				dispatch(getPayerReportByUser({ PayerFileds: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, MemberId, IsAllUsers }))
				break;
			case RECIPIENT_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				if (validatePayers(IsAllUsers)) {
					dispatch(getRecipientReport({ PayerIds: getPayerIdsArray(IsAllUsers), RecipientFileds: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, IsAllUsers }))
				}
				break;
			case TIN_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				if (validatePayers(IsAllUsers)) {
					dispatch(getTINReport({ PayerIds: getPayerIdsArray(IsAllUsers), PayerFileds: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx }))
				}
				break;
			case W9_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				if (validatePayers(IsAllUsers)) {
					dispatch(getW9Report({ PayerIds: getPayerIdsArray(IsAllUsers), W9ReportFields: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, IsAllUsers }))
				}
				break;
			case W8_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				if (validatePayers(IsAllUsers)) {
					dispatch(getW8Report({ PayerIds: getPayerIdsArray(IsAllUsers), W8ReportFields: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, IsAllUsers }))
				}
				break;
			case OPT_IN_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				if (validatePayers(IsAllUsers)) {
					dispatch(getOPTINReport({ PayerIds: getPayerIdsArray(IsAllUsers), OptInReportFields: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, IsAllUsers }))
				}
				break;
			case UNSUBMITTED_REPORT_VALUE:
				IsAllUsers = isAllUsersSelected()
				let selectedDropdown = selectedDropDownOption.value
				let multiSelected = multiSelectdropDownOptions.filter(opts => opts.checked).map(opt => opt.value).join(",")
				if (multiSelected === "") {
					let PayerIds = IsAllUsers ? 0 : selectedDropdown;
					dispatch(getUnsubmittedFormsReport({ payerId: PayerIds, fromDate, toDate, IsXlsx: isXlsx, taxYear: selectedSecondaryDropDownOptions.value, IsAllPayers: IsAllUsers }))
				} else {
					let PayerIds = IsAllUsers ? 0 : multiSelected;
					dispatch(getUnsubmittedFormsReport({ payerId: PayerIds, fromDate, toDate, IsXlsx: isXlsx, taxYear: selectedSecondaryDropDownOptions.value, IsAllPayers: IsAllUsers }))
				}
				break;
			case SUBMITTED_REPORT_VALUE:
				dispatch(getSubmissionHistoryReport({ fromDate, toDate, taxYear: selectedSecondaryDropDownOptions.value }))
				break;
			case STATE_SUBMITTED_REPORT_VALUE:
				dispatch(getStateSubmissionHistoryReport({ fromDate, toDate, taxYear: selectedSecondaryDropDownOptions.value }))
				break;
			case FORM_DELIVERY_REPORT_VALUE:
				dispatch(getFormDeliveryReport({ FormsDeliveryFields: formatHeaderForExport(), FromDate: fromDate, ToDate: toDate, IsXlsx: isXlsx, TaxYear: selectedSecondaryDropDownOptions.value }))
				break;
			case GENERATE_INVOICE_VALUE:
				dispatch(getInvoiceReport({ taxYear: selectedSecondaryDropDownOptions.value, fromDate, toDate }))
				break;
			case QBO_VENDOR_VALUE:
				dispatch(getQBOVendorHistoryReportExport())
				break;
			case EMAIL_REQUEST_VALUE:
				switch (tabbedIndex) {
					case 0:
						dispatch(get1099VendorCopyeDeliveryExport({ PayerId: selectedDropDownOption.value, taxYear: selectedSecondaryDropDownOptions.value, skip, rowsPerPage }))
						break;
					case 1:
						dispatch(getW9CopyStatusReportExport({ PayerId: selectedDropDownOption.value }))
						break;
					case 2:
						dispatch(getOptInEmailStatusGridExport({ PayerId: selectedDropDownOption.value }))
						break;
				}
				break;
			case PAYMENT_RECEIPTS_REPORT_VALUE:
				dispatch(getPaymentsReceiptsReportExport({ fromDate, toDate }))
				break;
			case STATE_PAYROLL_SUBMITTED_REPORT_VALUE:
				let formLabel = selectedForm.label;
				dispatch(getStatePayrollSubmissionHistoryReport({ formLabel, fromDate, toDate }))
				break;
		}
	}

	const handleSelectedOptionChange = (name, selectedOption) => {
		dispatch(setSelectedDropDownOption(selectedOption))
	}

	const handleReportChange = (name, selectedOption) => {
		setSelectedReport(selectedOption);
	}

	const handleSearchTextChange = (e) => {
		dispatch(setFilterText(e.target.value))
	}

	const handleMultiSelectChange = (options, index) => {
		const selectAll = options[index].value === ALL_SELECTED
		if (selectAll) {
			const updatedOptions = multiSelectdropDownOptions.map(opt => ({ ...opt, checked: options[index].checked }));
			dispatch(setMultiSelectdropDownOptions(updatedOptions));
			setSelectedPayersLabel(options[index].checked ? ALL_SELECTED : NONE_SELECTED);
		} else {
			const updatedOptions = multiSelectdropDownOptions.map(opt => {
				const foundOption = options.find(o => o.value === opt.value);
				if (foundOption) {
					return { ...opt, checked: foundOption.checked };
				}
				return opt;
			});
			dispatch(setMultiSelectdropDownOptions(updatedOptions));
			const selectedCount = updatedOptions.filter(opt => opt.checked).length;
			setSelectedPayersLabel(`${selectedCount ?? "None"} Selected`);
		}
	}

	const handleTaxChange = (name, selectedOption) => {
		dispatch(setSelectedSecondaryDropDownOptions(selectedOption))
	}

	const UNSUBMITTED_FORMS_REPORT_COLUMN = [
		{
			field: "payerName",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...styles.text }}>Payer Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PayerName}</span>
		},
		{
			field: "payerTIN",
			header: <Label weight={LABEL_WEIGHT[700]}>Payer TIN</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{formatTIN(row.PayerTaxIdType, row.PayerTaxId)}</span>
		},
		{
			field: "recipientName",
			header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PayeeName}</span>
		},
		{
			field: "recipientTIN",
			header: <Label weight={LABEL_WEIGHT[700]}>Recipient TIN</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{formatTIN(row.PayeeTaxIdType, row.PayeeTaxId)}</span>
		},
		{
			field: "formCreated",
			header: <Label weight={LABEL_WEIGHT[700]}>Form Created</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FormCreatedDate}</span>
		},
		{
			field: "formName",
			header: <Label weight={LABEL_WEIGHT[700]}>Form Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FormName}</span>
		},
		{
			field: "userName",
			header: <Label weight={LABEL_WEIGHT[700]}>User Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.UserName}</span>
		},
		{
			field: "taxYear",
			header: <Label weight={LABEL_WEIGHT[700]}>Tax Year</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TaxYear}</span>
		},
	]

	const VENDOR_COPY_COLUMN = [
		{
			field: "recipientName",
			header: <Label weight={LABEL_WEIGHT[700]}>Recipient Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.RecipientName}</span>
		},
		{
			field: "recipientTIN",
			header: <Label weight={LABEL_WEIGHT[700]}>Recipient TIN</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.RecipientTIN}</span>
		},
		{
			field: "email",
			header: <Label weight={LABEL_WEIGHT[700]}>Email Address</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.EmailAddress}</span>
		},
		{
			field: "status",
			header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.Status}</span>
		},
		{
			field: "dateSent",
			header: <Label weight={LABEL_WEIGHT[700]}>Date Sent</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{DateUtils.dateFormatter(row.DateSent)}</span>
		},
		{
			field: "edit",
			header: <Label weight={LABEL_WEIGHT[700]}>Edit</Label>,
			renderLogic: (row, idx) => <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => {
				setSelectedRecipient(row)
				setShowEditDrawer(true)
			}}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} /></Button>
		},
	]

	const QBO_VENDOR_COLUMN = [
		{
			field: "vendorID",
			header: <Label weight={LABEL_WEIGHT[700]}>Vendor ID</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PayeeName}</span>
		},
		{
			field: "EIN/SSN",
			header: <Label weight={LABEL_WEIGHT[700]}>EIN/SSN</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.PayeeTaxId}</span>
		},
		{
			field: "firstName",
			header: <Label weight={LABEL_WEIGHT[700]}>First Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.FormCreatedDate}</span>
		},
		{
			field: "middleName",
			header: <Label weight={LABEL_WEIGHT[700]}>Middle Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.UserName}</span>
		},
		{
			field: "lastName",
			header: <Label weight={LABEL_WEIGHT[700]}>Last Name</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TaxYear}</span>
		},
		{
			field: "updateDate",
			header: <Label weight={LABEL_WEIGHT[700]}>Update Date</Label>,
			renderLogic: (row, idx) => <span style={{ ...styles.text }}>{row.TaxYear}</span>
		},
	]

	const handlePopupClose = () => {
		dispatch(setMultiSelectdropDownOptions(multiSelectdropDownOptions.map(opt => ({ ...opt, checked: false }))));
		setSelectedPayersLabel(SELECT_PAYERS);
		setShowPopup(false);
	}

	useEffect(() => {
		if (selectedState?.value) {
			dispatch(getStatePayrollReportForms({ stateNames: selectedState?.value }));
		} else {
			dispatch(setFormList([]));		
		}
		dispatch(setSelectedForm({ label: "", value: "" }))
	}, [selectedState])

	const getGridHeaders = () => {
		switch (selectedReport?.value) {
			case UNSUBMITTED_REPORT_VALUE:
				return UNSUBMITTED_FORMS_REPORT_COLUMN;
			case EMAIL_REQUEST_VALUE:
				return VENDOR_COPY_COLUMN;
			case QBO_VENDOR_VALUE:
				return QBO_VENDOR_COLUMN;

		}
	}

	const isGridSelectable = () => {
		return selectedReport?.value === EMAIL_REQUEST_VALUE && tabbedIndex === 0;
	}

	const handleEmailChange = () => {
		dispatch(updateEmailId({
			data: selectedRecipient, callbackFn: () => {
				setReloadData(prev => !prev)
				setShowEditDrawer(false)
			}
		}))
	}

	const handleSecondaryButtonClick = () => {
		if (selectedReport?.value === EMAIL_REQUEST_VALUE && tabbedIndex === 0) {
			if (isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions)) {
				const bodyData = {
					"AllSelected": false,
					"payername": selectedDropDownOption.label,
					"taxYear": selectedSecondaryDropDownOptions.value,
					"data1": selectedRows.map(row => ({
						IsSelect: "true",
						UserId: row.UserId,
						EmailStatusId: row.EmailStatusId,
						PayerName: row.PayerName,
						RecipientName: row.RecipientName,
						EmailAddress: row.EmailAddress,
						RecipientTIN: row.RecipientTIN,
						Status: row.Status,
						DateSent: row.DateSent
					})),
					"payerId": selectedDropDownOption.value

				}
				dispatch(getUSPSAmount(bodyData))
			} else {
				dispatch(setShowPaymentNotAllowedPopup(true))
			}
		} else {
			setShowPopup(true)
		}
	}

	return (
		<>
			<div>
				{selectedReport?.value === FORM_DELIVERY_REPORT_VALUE &&
					<div style={styles.noticeRow}>
						<div>Choose Forms Delivery Report headers that you want to export to excel.</div>
						<div><b>Note:</b> Tax1099 is not responsible for the delivery of any USPS mail.</div>
					</div>
				}
				<div>
					<div>
						<label style={styles.lableText}>Select Report</label>
						<div style={styles.calendarBox}>
							<SelectDropdown
								name="report"
								value={selectedReport}
								prefixProps={{ text: "" }}
								onSelectCb={(name, selectedOption) => handleReportChange(name, selectedOption)}
								options={reportOptions}
								isClearable={false}
							/>
						</div>
					</div>
				</div>
				<Loadable currentState={loadingState.state} loadingStates={[REPORT_LOADING_STATES.FILTER_LOADING, REPORT_LOADING_STATES.SECONDARY_ACTION_LOADING, REPORT_LOADING_STATES.REPORT_RUN_LOADING, REPORT_LOADING_STATES.HEADERS_LOADING, REPORT_LOADING_STATES.GRID_LOADING]} messageMap={REPORT_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} >

					{showTabbedNavigation &&
						<TabbedNavigationWithDefinedTitle onChangeTabCb={index => setTabbedIndex(index)} tabListWithTitleObj={tabListWithTitleObj} />
					}


					<div style={styles.dropdownGroup}>
						{showSelectDropdon &&
							<div>
								<div>
									<label style={styles.lableText}>{dropdownLabel}</label>
									<div style={styles.calendarBox}>
										<SelectDropdown
											name="select"
											value={{ label: selectedDropDownOption.label, value: selectedDropDownOption.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => handleSelectedOptionChange(name, selectedOption)}
											options={dropDownOptions}
											onSearchInputChangeCb={handleSearchTextChange}
										/>
									</div>
								</div>
							</div>
						}

						{showMultiSelectDropdown &&
							<div>
								<div>
									<label style={styles.lableText}>Select Payer</label>
									<div style={styles.calendarBox}>
										<MultiSelectDropdown
											label="Select Payer"
											options={multiSelectdropDownOptions}
											onSelectOptionsCb={(updatedOptions) => dispatch(setMultiSelectdropDownOptions(updatedOptions))}
										/>
									</div>
								</div>
							</div>
						}

						{!showFormList && secondaryDropDownOptions && secondaryDropDownOptions.length > 0 &&
							<div>
								<div>
									<label style={styles.lableText}>{secondaryDropdownLabel}</label>
									<div style={styles.calendarBox}>
										<SelectDropdown
											name="taxYear"
											value={{ label: selectedSecondaryDropDownOptions.label, value: selectedSecondaryDropDownOptions.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => handleTaxChange(name, selectedOption)}
											options={secondaryDropDownOptions}
										/>
									</div>
								</div>
							</div>
						}
						{showStateList && stateList &&
							<div>
								<div>
									<label style={styles.lableText}>State</label>
									<div style={styles.calendarBox}>
										<SelectDropdown
											name="States"
											value={{ label: selectedState?.label, value: selectedState?.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => {
												dispatch(setPayrollSelectedState(selectedOption));
											}}
											options={stateList}
										/>
									</div>
								</div>
							</div>
						}
						{
						showFormList && formList &&
							<div>
								<div>
									<label style={styles.lableText}>Forms</label>
									<div style={styles.calendarBox}>
										<SelectDropdown
											name="formName"
											value={{ label: selectedForm?.label, value: selectedForm?.value }}
											prefixProps={{ text: "" }}
											onSelectCb={(name, selectedOption) => {
												dispatch(setSelectedForm(selectedOption));
											}}
											options={formList}
										/>
									</div>
								</div>
							</div>
						}
						{showDataFilter &&
							<div>
								<div>
									<label style={styles.lableText}>Select the Dates for Report</label>
									<div style={styles.calendarBox}>

										<CalendarInput name="fromDate" label={'FROM'} value={fromDate} customStyle={styles.calendar} onChangeCb={onChangeCalendarInputCb} />
										<CalendarInput name="toDate" label={'TO'} value={toDate} customStyle={styles.calendar} onChangeCb={onChangeCalendarInputCb} />
									</div>
								</div>
							</div>
						}
					</div>

					{/* hiding the option for now as we dont have any other option to select while exporting  */}
					{showExtension && false &&
						<div>
							<label style={styles.lableText}>Select file format to export</label>
							<div style={styles.extensionContainer}>

								<RadioInputWCard
									name="extension"
									label={
										{ prefixLabel: ". xlsx" }
									}
									value={"XLSX"}
									checked={isXlsx}
									onChangeCb={onChangeFileFormatCb}
									iconName={VEC_ICON_NAME.EXCEL_SHEET_LOGO}
								/>

							</div>
						</div>
					}
					{showGrid &&
						<RichGrid
							data={gridData}
							columns={getGridHeaders()}
							selectable={isGridSelectable()}
							extractRowKey={(row) => row.EmailStatusId}
							selectedRows={selectedRows}
							onSelectionChangeCallBack={(selectedData) => setSelectedRows(selectedData)}
							onHeaderSelectionChangeCallBack={(selectedData) => setSelectedRows(selectedData)}
							paginationProps={{
								skip: skip,
								take: rowsPerPage,
								takeOptions: ROW_SELECTION_OPTIONS,
								onChangeTakeCb: (newTake) => {
									dispatch(setRowsPerPage(newTake));
									dispatch(setSkip(0))
								},
								total: gridTotal,
								onChange: (take, t) => {
									dispatch(setRowsPerPage(take));
									dispatch(setSkip(t))
								},
							}}
						/>
					}
					{showHeaders && headers &&
						<div>
							<label style={styles.lableText}>Select the Headers for Report</label>
							<div>
								<div style={styles.selectAllCBox}>
									<CheckboxWLabel checked={headers.some(item => item.value)} iconName={VEC_ICON_NAME.CHECKBOX_DASH_ICON} label={SELECT_ALL} name="selectAll" onChangeCb={onChangeSelectAllCb} />
								</div>

								<HorizontalSeparator style={styles.horizontalLine} />

								<div style={styles.checkboxContainer}>

									{headers.map((item, idx) => (
										<CheckboxWLabel iconName={VEC_ICON_NAME.CHECKBOX_ICON} label={item.label} name={item.key} checked={item.value} onChangeCb={(event) => onChangeReportHeadersCb(event)} />
									))}
								</div>
							</div>
						</div>
					}
					<div style={styles.buttonRow}>
						<Button onClickCb={handleRunReport}>Export to Excel</Button>
						{
							showSecondaySubmitButton &&
							<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.runReportButton} onClickCb={handleSecondaryButtonClick}>{secondarySubmitLabel}</Button>
						}
					</div>
				</Loadable>

			</div>
			<Popup isPopupOpen={showPopup} onCloseCb={() => setShowPopup(false)} customPopupSyles={styles.customPopupSyles} childrenStyles={styles.childrenStyles}>
				<Heading type={HEADING.H2}>Export To Excel For Multiple Payers</Heading>
				<Loadable currentState={loadingState.state} loadingStates={[REPORT_LOADING_STATES.REPORT_RUN_LOADING]} messageMap={REPORT_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} >
					{multiSelectdropDownOptions &&
						<div style={styles.exportForMultipleExport}>
							<div>
								<label style={styles.lableText}>{multiSelectLabel}</label>
								<div style={styles.calendarBox}>
									<MultiSelectDropdownWLabel
										label={selectedPayersLabel}
										options={multiSelectdropDownOptions.slice(0, payerDropdownPagination?.PageSize * payerDropdownPagination?.PageNumber)}
										onChangeCheckboxCb={(options, index) => handleMultiSelectChange(options, index)}
										buttonProps={[]}
										customDropDownStyles={styles.customMultiSelect}
										onDropdownTouchedToBottomCb={() => {
											if (payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < multiSelectdropDownOptions?.length) {
												dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
											}
										}}
									/>
								</div>
							</div>
							<div style={styles.buttonRow}>
								<Button style={styles.runReportButton} onClickCb={handleRunReport}>Submit</Button>
								<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.runReportButton} onClickCb={handlePopupClose}>Cancel</Button>
							</div>
						</div>
					}
				</Loadable>
			</Popup>

			{showEditDrawer &&
				<DrawerWithTitleAndFooter isOpen={showEditDrawer} onCloseCb={() => setShowEditDrawer(false)} title={"Edit Recipient"}>
					<div>
						<Loadable currentState={loadingState.state} loadingStates={[REPORT_LOADING_STATES.UPDATE_EMAIL_LOADING]} messageMap={REPORT_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} >
							<div style={styles.editBox}>
								<div style={styles.editBoxInputWidth}>
									<Label customStyles={{ ...styles.text }}>Recipient Name</Label>
									<TextInput
										disabled={true}
										value={selectedRecipient.RecipientName}
									/>
								</div>

								<div style={styles.editBoxInputWidth}>
									<Label customStyles={{ ...styles.text }}>Recipient TIN</Label>
									<TextInput
										disabled={true}
										value={selectedRecipient.RecipientTIN}
									/>
								</div>
							</div>

							<div style={styles.editBox}>
								<div style={styles.editBoxInputWidth}>
									<Label customStyles={{ ...styles.text }}>Email Address</Label>
									<TextInput
										value={selectedRecipient.EmailAddress}
										onChangeCb={(e) => setSelectedRecipient({ ...selectedRecipient, EmailAddress: e.target.value })}
									/>
								</div>

								<div style={styles.editBoxInputWidth}>
									<Label customStyles={{ ...styles.text }}>Status</Label>
									<TextInput
										disabled={true}
										value={selectedRecipient.Status}
									/>
								</div>
							</div>

							<div style={styles.editBox}>
								<div style={styles.editBoxInputWidth}>
									<Label customStyles={{ ...styles.text }}>Date Sent</Label>
									<TextInput
										disabled={true}
										value={DateUtils.dateFormatter(selectedRecipient.DateSent)}
									/>
								</div>
							</div>
							<div style={styles.editActionsRow}>
								<Button onClickCb={handleEmailChange}>Save</Button>
								<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => setShowEditDrawer(false)}>Cancel</Button>
							</div>
						</Loadable>
					</div>
				</DrawerWithTitleAndFooter>
			}

			{
				uspsAmount !== 0 && <PaymentDrawer
					isOpen={uspsAmount !== 0}
					isUsps={true}
					onCloseCb={() => {
						dispatch(setUSPSAmount(0))
					}}
					fees={{
						OnlySeparateStatefiling: "false",
						TotalFilingFee: uspsAmount,
						FilingFee: uspsAmount,
						USPSFee: "0",
						TINMatchFee: "0",
						StateFee: "0",
						TINCount: "0",
						StateFilingCount: "0",
						USPSCount: "0",
						FormCount: "0"
					}}
					filingFeeLabel={`USPS Mail to recipient fees`}
					paymentServiceFunctionCb={ReportDataService.USPSMailTORecipient}
					calculatePrepaySalesTax={true}
					paymentServiceFunctionExtraParams={{
						data1: selectedRows.map(row => ({
							IsSelect: "true",
							UserId: row.UserId,
							EmailStatusId: row.EmailStatusId,
							PayerName: row.PayerName,
							RecipientName: row.RecipientName,
							EmailAddress: row.EmailAddress,
							RecipientTIN: row.RecipientTIN,
							Status: row.Status,
							DateSent: row.DateSent
						}))
					}}
					calculateEstimatedTax={true}
					placeOfOriginforpayment={PLACE_OF_ORIGIN_FOR_PAYMENT.USPS_PAYMENT}
					onPaymentSuccessCb={() => {
						dispatch(setUSPSAmount(0))
					}}
				/>

			}
		</>
	)
}